import {FormState} from '../../models/form-state.model';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {ExportXmlActions} from './export-xml.actions';
import {clearFormValidationErrors, setFormValidationErrors} from '../../helpers/form.helper';
import {ModalService} from '../../services/modal.service';
import {ExportXmlService} from '../../services/export-xml.service';
import {ConfirmationModalComponent} from '../../modules/shared/components/confirmation-modal';
import {TranslateService} from '@ngx-translate/core';
import {PartnerActions} from '../partner/partner.actions';
import {PartnerListFilter} from '../../models/partner.model';
import {tap} from 'rxjs/operators';

interface ExportXmlStateModel {
    form: FormState;
}

const STATE_NAME = 'exportXml';

@State<ExportXmlStateModel>({
    name: STATE_NAME,
    defaults: {
        form: new FormState(),
    }
})

@Injectable()
export class ExportXmlState {
    constructor(
        private modalService: ModalService,
        private exportXmlService: ExportXmlService,
        private translateService: TranslateService,
    ) {
    }

    @Selector()
    static exportXmlErrors(state) {
        return state.form.validationErrors;
    }

    @Action(ExportXmlActions.OpenModal)
    openModal(ctx: StateContext<ExportXmlStateModel>) {
        return ctx.dispatch(new PartnerActions.FieldList(
            new PartnerListFilter({active: true, virtual: false, orderByField: 'nameShort'}))
        )
            .pipe(
                tap(() => {
                    this.exportXmlService.openModal(ctx);
                })
            );
    }

    @Action(ExportXmlActions.Export)
    exportXML(ctx: StateContext<ExportXmlStateModel>) {
        const xmlData = ctx.getState().form.model;
        this.exportXmlService.exportXml(xmlData).subscribe(() => {
                clearFormValidationErrors(ctx);
                this.exportXmlService.closeModal();
                this.modalService.generic({
                    nzContent: ConfirmationModalComponent,
                    nzFooter: [
                        {
                            label: this.translateService.instant('LABELS.CLOSE'),
                            type: 'primary',
                            onClick: (component: ConfirmationModalComponent) => {
                                component.close();
                            },
                        }
                    ],
                    nzKeyboard: false,
                    nzClosable: false,
                    nzMaskClosable: false,
                    nzComponentParams: {confirmationText: this.translateService.instant('EXPORT_XML.MODAL.CONFIRMATION')},
                });
            },
            ({error}) => setFormValidationErrors(ctx, error, STATE_NAME));
    }

}
